import { Divider, Radio } from 'antd';

import WizardContentBox from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardContentBox';
import WizardQuestionHelp from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardQuestionHelp';
import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';
import WizardTitle from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardTitle';
import { WizardDescription } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardDescription';
import { wizardQuestionStepKeys } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/constants/wizardQuestionStepKeys';

const YesNoStep = ({ step, children }) => {
  const { state, actions } = useWizard();

  const { content, field, help } = step;
  const value = state.answers[field];

  const handleChange = (e) => {
    actions.setAnswer(field, e.target.value);
  };

  return (
    <WizardContentBox>
      <WizardTitle title={content.title} />
      <Divider />
      <div className='wizard-question-rows'>
        <div className='wizard-question-row'>
          <WizardDescription>{content.question}</WizardDescription>
          <Radio.Group value={value} onChange={handleChange}>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </div>
        {children}
      </div>

      <WizardQuestionHelp help={help} stepKey={wizardQuestionStepKeys[field]} />
    </WizardContentBox>
  );
};

export default YesNoStep;
